import {
  USGA_COURSE_DRAFT_COLLECTION as SharedUsgaCourseDraftCollection,
  USGA_COURSE_SEARCH_COLLECTION as SharedUsgaCourseSearchCollection,
  USGA_COURSE_SEARCH_STATUSES as SharedUsgaCourseSearchStatuses,
} from "shared/dist/types/UsgaCourseSearch";

export type {
  UsgaCourseDraft,
  UsgaCourseDraftCourse,
  UsgaCourseSearch,
  UsgaCourseSearchResult,
  UsgaCourseSearchStatus,
} from "shared/dist/types/UsgaCourseSearch";

export const USGA_COURSE_DRAFT_COLLECTION = SharedUsgaCourseDraftCollection;
export const USGA_COURSE_SEARCH_COLLECTION = SharedUsgaCourseSearchCollection;
export const USGA_COURSE_SEARCH_STATUSES = SharedUsgaCourseSearchStatuses;
